import { render, staticRenderFns } from "./completRegister.vue?vue&type=template&id=12e8c31e&"
import script from "./completRegister.vue?vue&type=script&lang=js&"
export * from "./completRegister.vue?vue&type=script&lang=js&"
import style0 from "./completRegister.vue?vue&type=style&index=0&id=12e8c31e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports